import { RESORTS_WEB } from '../config/ids/idsResorts';

/**
 *
 */
export const state = () => ({
    currentResortId: null,
    currentSeason: null,
    isWebPEnabled: false,
    isWebPCheckFinished: false,
    isLegacyBrowser: false,
    isNativeApp: false,
    fatalError: null,
});

export const mutations = {
    setCurrentResortId(state, payload) {
        state.currentResortId = payload;
    },

    setCurrentSeason(state, payload) {
        state.currentSeason = payload;
    },

    setIsNativeApp(state, flag) {
        state.isNativeApp = flag;
    },

    setIsWebPEnabled(state, flag) {
        state.isWebPEnabled = flag;
    },

    setIsWebPCheckFinished(state, flag) {
        state.isWebPCheckFinished = flag;
    },

    setIsLegacyBrowser(state, flag) {
        state.isLegacyBrowser = flag;
    },

    setFatalError(state, payload) {
        state.fatalError = payload;
    },
};

export const actions = {
    async checkWebP({ commit }) {
        let result = false;
        if (window.Modernizr) {
            result = await new Promise(resolve => window.Modernizr.on('webp', resolve));
        }
        commit('setIsWebPEnabled', result);
        commit('setIsWebPCheckFinished', true);
    },
};

export const getters = {
    webResortIds(state) {
        return RESORTS_WEB[state.currentSeason];
    },
};
